// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"xO","iconEffect":"xP","ripple":"xQ","a":"xR"};